module.exports = __webpack_public_path__ + "static/media/Search.c8abd9f8.svg";